import { ChangeDetectorRef, Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { take } from 'rxjs';
import { GeneralSettingsService } from 'src/app/services/shared/general-settings.service';

@Directive({
  selector: '[terraSystemFeatureFlag]'
})
export class SystemFeatureFlagDirective {
  @Input() set terraSystemFeatureFlag(featureFlagKey: string){
    this.viewContainer.clear();

    this.generalSettingsService.systemFeatureFlagKeysValues$.pipe(
      take(1)
    )
    .subscribe({
      next: featureFlagKeysValues => {
        if (featureFlagKeysValues[featureFlagKey]) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.cdr.markForCheck();
        }
      },
      error: err => {}
    });
  }; 

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private generalSettingsService: GeneralSettingsService,
    private cdr: ChangeDetectorRef
  ) { 

  }
}
